module.exports = __webpack_public_path__ + "img/rocket-damage.29ea1fea.png";